var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperGenerationDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8184 26.9467H6.81835C5.16149 26.9467 3.81835 25.6035 3.81836 23.9467L3.81848 5.94676C3.81849 4.28991 5.16163 2.94678 6.81848 2.94678H20.3188C21.9757 2.94678 23.3188 4.28992 23.3188 5.94678V11.9468M9.06883 8.94678H18.0688M9.06883 13.4468H18.0688M9.06883 17.9468H13.5688M17.3186 22.8106L23.6826 16.4466L27.9252 20.6892L21.5612 27.0532H17.3186V22.8106Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperGenerationDark);
export default __webpack_public_path__ + "static/media/paper-generation-dark.43b9802198ade82eae6a3422a2fe55cc.svg";
export { ForwardRef as ReactComponent };